// meetingModel.js
import { collection, doc } from "firebase/firestore";
import { db } from "../../firebase/firebase.js";

export const meetingsCollection = collection(db, "meetings");

export const meetingDoc = (id) => doc(db, "meetings", id);

